export function setUploadFiles (state, files) {
  state.files = files
}

export function clearUploadFiles (state) {
  state.files = []
}
